<template>
    <div class="land-neopark-district-section">
        <disMain></disMain>
        <div class="content-bg">
            <disLocation></disLocation>
            <disParks></disParks>
            <disAround></disAround>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    import disMain from '@/components/sales-land-partials/neopark/neopark-dis-main.vue';
    import disLocation from '@/components/sales-land-partials/neopark/neopark-dis-location.vue';
    import disParks from '@/components/sales-land-partials/neopark/neopark-dis-parks.vue';
    import disAround from '@/components/sales-land-partials/neopark/neopark-dis-around.vue';
    export default {
        name: 'sale-land-neopark-district',
        components: {
            disMain,
            disLocation,
            disParks,
            disAround,
        },
        data () {
            return {
                projectNameG: window.host,
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    .content-bg {
        background-color: #66726a;
        margin-top: 60px;
        padding-bottom: 65px;
        margin-bottom: 60px;
        @media (max-width:$mobile-respond-portrait) {
            margin-top: -5px;
            padding-bottom: 15px;
            margin-bottom: 0;
        }
    }
</style>